/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import './elements-mpin.js';

class mpinSetupLanding extends mixinBehaviors([], PolymerElement) {
  /** Properties definition*/
  static get properties() {
    return {
      selected: {
        type: Number,
        notify: true,
        observer: 'updateAuthMethod'
      },
      successMsg: {
        type: String,
        notify: true
      },
      authMethod: {
        type: Object,
        notify: true // value: [{ method: 'SOTP', wrapperValue: "", resend: "./random_link/" }]
        //value:  [{method:'TPWD',elementName: 'fin-auth-transaction-pwd',wrapperValue:"",resend:"./random_link/"}]
        //value:  [{method:'DBTCARD',elementName: 'fin-auth-debit-card',wrapperValue:"",resend:"./random_link/"}]
        //value:  [{method:'SOTP',elementName: 'fin-auth-otp',wrapperValue:"",resend:"./random_link/"}]

      },
      selectedPage: {
        type: Number,
        notify: true
      },
      show: {
        type: Boolean,
        notify: true
      },
      authPage: {
        type: Object,
        value: {
          "oneTimePassword": 0,
          "securityQuestionAnswers": 1,
          "creditCardDetails": 2,
          "debitCardDetails": 3,
          "signOnPassword": 4
        }
      },
      phone: {
        type: String,
        notify: true,
        observer: 'changeStyle'
      },
      showHeader: {
        type: Boolean,
        value: true
      },
      profilePage: {
        type: Boolean,
        value: false,
        notify: true
      },
      questionList: {
        type: Object,
        notify: true
      },
      otpValue: {
        type: String,
        notify: true
      },
      mpinAuthList: {
        type: Object,
        notify: true,
        observer: 'listChanged'
      },
      showUserName: {
        type: String,
        notify: true,
        observer: '_checkShowUserName'
      },
      hideShowUserName: {
        type: Boolean,
        notify: true,
        value: true
      },
      authorizationDetailsBody: {
        type: Object,
        notify: true,
        value: {}
      }
    };
  }
  /** HTML template definition*/


  static get template() {
    return html`
        <style include="corp-app-styles">
        </style>
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
				<!-- Kindly add any new iron page at the end -->
        <iron-pages slot="content" selected="{{selectedPage}}" class="light-background backgroundColorHeight">
        <mpin-prelogin-auth selected-page={{selectedPage}}  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" selected={{selected}} show="{{show}}" authorization-details-body="{{authorizationDetailsBody}}"
            auth-page="{{authPage}}" mpin-auth-list="{{mpinAuthList}}" auth-method={{authMethod}} show="{{show}}"
            otp-value="{{otpValue}}" profile-page="{{profilePage}}" show-user-name={{showUserName}} hide-show-user-name={{hideShowUserName}}></mpin-prelogin-auth>
        <mpin-prelogin-security-question selected-page={{selectedPage}}  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" auth-page="{{authPage}}" authorization-details-body="{{authorizationDetailsBody}}"
            question-list="{{questionList}}" profile-page="{{profilePage}}"  mpin-auth-list="{{mpinAuthList}}" otp-value="{{otpValue}}" show-user-name={{showUserName}}
            hide-show-user-name={{hideShowUserName}} selected={{selected}}></mpin-prelogin-security-question>
        <mpin-credit-card-details selected-page="{{selectedPage}}"  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" selected={{selected}} show="{{show}}" mpin-auth-list="{{mpinAuthList}}" authorization-details-body="{{authorizationDetailsBody}}"
        hide-show-user-name={{hideShowUserName}} profile-page="{{profilePage}}" auth-page="{{authPage}}" show-user-name={{showUserName}} success-msg="{{successMsg}}"></mpin-credit-card-details>
        <mpin-debit-card-details selected-page="{{selectedPage}}"  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" selected={{selected}} show="{{show}}" mpin-auth-list="{{mpinAuthList}}" authorization-details-body="{{authorizationDetailsBody}}"
          hide-show-user-name={{hideShowUserName}} profile-page="{{profilePage}}" auth-page="{{authPage}}" show-user-name={{showUserName}} success-msg="{{successMsg}}"></mpin-debit-card-details>
        <mpin-sign-on-password selected-page="{{selectedPage}}" profile-page="{{profilePage}}"  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" selected={{selected}} show="{{show}}" mpin-auth-list="{{mpinAuthList}}" authorization-details-body="{{authorizationDetailsBody}}"
        hide-show-user-name={{hideShowUserName}} show-user-name={{showUserName}} auth-page="{{authPage}}" success-msg="{{successMsg}}"></mpin-sign-on-password>
        <set-mpin selected-page="{{selectedPage}}" profile-page="{{profilePage}}"  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" selected={{selected}} show="{{show}}" mpin-auth-list="{{mpinAuthList}}" authorization-details-body="{{authorizationDetailsBody}}"
           hide-show-user-name={{hideShowUserName}} auth-page="{{authPage}}" show-user-name={{showUserName}} success-msg="{{successMsg}}"></set-mpin>
           <mpin-change-password selected-page="{{selectedPage}}" profile-page="{{profilePage}}"  otp={{otp}} activate-response="{{activateResponse}}" enabled-auth-list="{{enabledAuthList}}" selected={{selected}} show="{{show}}" mpin-auth-list="{{mpinAuthList}}" authorization-details-body="{{authorizationDetailsBody}}"
           hide-show-user-name={{hideShowUserName}} auth-page="{{authPage}}" show-user-name={{showUserName}} success-msg="{{successMsg}}"></mpin-change-password>
          </iron-pages>

        `;
  }


  _checkShowUserName() {
    if (this.showUserName === '' || this.showUserName === undefined) this.hideShowUserName = true;
    else this.hideShowUserName = false;
  }
  listChanged() {
    if (this.mpinAuthList && this.mpinAuthList.authenticationDetails) {
      const authenticationDetails = this.mpinAuthList.authenticationDetails;
      this.questionList = authenticationDetails.securityQuestionAnswers != undefined ? authenticationDetails.securityQuestionAnswers : [];
      this.enabledAuthList = Object.keys(authenticationDetails);

      if (this.enabledAuthList && this.enabledAuthList.length > 0) {
        this.selected = 16;
        this.selectedPage = this.authPage[this.enabledAuthList[0]];
      }
    }
  }

  changeStyle() {
    this.updateStyles();
  }
  updateAuthMethod() {
    if (this.selected == 16) {
      this.authMethod = [];
      this.authMethod = [{
        method: 'SOTP',
        wrapperValue: "",
        resend: "./random_link/"
      }];
    }
  }
}

customElements.define('mpin-setup-landing', mpinSetupLanding);